import { ModalHeaderComponent } from './modal-header/modal-header.component';
import { ModalActionsComponent } from './modal-actions/modal-actions.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SvgSourceModule } from '@app/shared/ui/svg-source/svg-source.module';
import { ModalBodyComponent } from './modal-body/modal-body.component';
import { ModalComponent } from './modal.component';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DirectivesModule } from '@app/shared/directives/directives.module';
import { ResizeSensorComponent } from '@progress/kendo-angular-common';

@NgModule({
  imports: [CommonModule, SvgSourceModule, ButtonsModule, DirectivesModule, ResizeSensorComponent],
  declarations: [ModalComponent, ModalActionsComponent, ModalBodyComponent, ModalHeaderComponent],
  exports: [ModalComponent, ModalActionsComponent, ModalBodyComponent, ModalHeaderComponent],
})
export class ModalModule {}
